/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var ColumnPropertySetter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ColumnPropertySetter, _super);
    function ColumnPropertySetter(a) {
        var _rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _rest[_i - 1] = arguments[_i];
        }
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.c = null;
        _this.d = null;
        _this.b = null;
        a = (a == void 0) ? 0 : a;
        switch (a) {
            case 0: break;
            case 1:
                {
                    var c = _rest[0];
                    var d = _rest[1];
                    var e = _rest[2];
                    _this.c = c;
                    _this.d = d;
                    _this.b = e;
                }
                break;
        }
        return _this;
    }
    ColumnPropertySetter.$t = markType(ColumnPropertySetter, 'ColumnPropertySetter');
    return ColumnPropertySetter;
}(Base));
export { ColumnPropertySetter };
//# sourceMappingURL=ColumnPropertySetter.js.map
